export type { ProductHeroSectionProps } from './ProductHeroSection';
export { default } from './ProductHeroSection';
